import React from 'react'

// Miniatura da curva de envios, para quando o gráfico completo está recolhido.
// Não substitui o gráfico: o papel dela é responder "está subindo ou caindo?"
// sem custar meia tela — quem precisa dos números por dia abre o gráfico.
//
// Sem eixo e sem grade de propósito: numa faixa de ~34px, régua e rótulos viram
// ruído. A escala é a própria série (o maior valor encosta no topo).
export default function Sparkline({ data = [], color = '#059669', width = 300, height = 34 }) {
  const pontos = (data || []).map((n) => (Number.isFinite(Number(n)) ? Number(n) : 0))

  // Uma amostra só não desenha linha; abaixo disso não vale ocupar espaço.
  if (pontos.length < 2) return null

  const maior = Math.max(...pontos, 1)
  const passo = width / (pontos.length - 1)
  // margem de 2px em cima e embaixo pra espessura do traço não ser cortada
  const alturaUtil = height - 4
  const coordenadas = pontos.map((valor, i) => {
    const x = i * passo
    const y = height - 2 - (valor / maior) * alturaUtil
    return `${x.toFixed(1)},${y.toFixed(1)}`
  })

  const linha = `M${coordenadas.join(' L')}`
  const area = `${linha} L${width},${height} L0,${height} Z`

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className="block w-full"
      style={{ height }}
      aria-hidden="true"
      focusable="false"
    >
      <path d={area} fill={color} opacity="0.16" />
      <path d={linha} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  )
}
